import styled from 'styled-components';

export const Container = styled.div`
  background: #0000ff;
  background: #fff;
  transition: background-color 180ms ease-out;
  font-size: 1.4em;

  .conertTime {
    text-transform: uppercase;
    margin-right: 50px;
    color: #000;
    font-family: 'GT America';
    font-weight: bold;
    font-style: italic;
    font-size: 0.75em;
    flex-shrink: 0;
    min-width: 70px;
  }

  .left {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding-right: 15px;
    max-width: 850px;
  }

  .venue {
    text-transform: uppercase;
    font-family: 'GT America';
    font-weight: 500;
    font-style: normal;
    font-size: 0.75em;
    line-height: 1.4;
    color: #000;

    &:hover {
      color: #000;
    }
  }

  .details {
    display: flex;
    flex-direction: column;
    position: relative;
    top: -2px;
  }

  .buttonWrapper {
  }

  .buy {
    box-sizing: border-box;
    padding: 10px 10px 10px 12px;
    text-decoration: none;
    margin-left: 10px;
    text-transform: uppercase;
    color: #fff;
    font-family: 'GT America';
    font-weight: bold;
    font-style: italic;
    font-size: 0.6em;
    background: #000;
    align-self: flex-start;
    background: linear-gradient(
      89.91deg,
      #6530cf 0.64%,
      #1032f2 23.92%,
      #83e460 43.07%,
      #efe755 61.69%,
      #df7c36 80.84%,
      #d24237 99.98%
    );
    &:hover {
      color: #000;
      background: #fff;
    }

    &:first-child {
      margin-left: 0;
    }
  }

  .acts {
    display: flex;
    margin-top: 10px;
    font-family: 'GT America';
    font-weight: 300;
    flex-wrap: wrap;
    text-transform: uppercase;
    font-size: 0.75em;
    font-style: italic;
    color: #3c31e0;
    span {
      margin-right: 7px;
    }
    @media (max-width: 600px) {
      font-size: 0.9em;
    }
  }

  @media (max-width: 600px) {
    .conertTime {
      margin-bottom: 15px;
    }

    .left {
      flex-direction: column;
    }

    .buttonWrapper {
      margin-top: 20px;
    }
  }

  &:hover {
    .conertTime,
    .acts {
      color: #0000ff;
    }

    .venue {
      color: #000;
    }
  }

  &:hover {
    background-color: #fff;
  }
`;

export const Box = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1180px;
  width: 100%;
  margin: 0 auto;
  padding: 25px 30px;
  box-sizing: border-box;
  border-bottom: 1px solid #0000ff;

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;
